import { createFileRoute } from "@tanstack/react-router"
import { InterfaceLanguagePage } from "@/pages/profile/interface-language"

export const Route = createFileRoute(
	"/_authenticated/profile/interface-language",
)({
	component: InterfaceLanguagePage,
})
